export default __webpack_public_path__ + "static/media/preview.a92dfc72.png";